module.exports = __webpack_public_path__ + "img/lv.385a3214.jpg";